"use client";

import { usePaddle } from "@/hooks/use-paddle";

export function PaddleProvider() {
	usePaddle();

	return <></>;
}
